// v-NumberOnly="{model: data variable from component, isPositive: Boolean. Enable only positive.}"

const NumberOnly = {
  bind (el, binding, vnode) {
    // console.log('NUMBER ONLY directive has bound', el)
  },
  update (el, binding, vnode) {
    let regex = binding.value.isPositive ? /\d/g : /^\-?[1-9]\d{0,2}(\.\d*)?$/
    if (!regex.test(el.value)) {
      el.value = el.value.slice(0, -1)
    } else {
      if (el.value && el.value.includes('.')) {
        let decimal = el.value.split('.')[1]
        if (decimal.length > 2) {
          el.value = parseFloat(el.value).toFixed(2)
        }
      }
    }
    vnode.context[binding.value.model] = el.value
  }
}

export default NumberOnly



// WEBPACK FOOTER //
// ./src/Directives/NumberOnly.js